import React from "react";
import { Facebook, Instagram, LinkedIn, Twitter } from "@mui/icons-material";
import WebGraphic from "../../../../Assets/Images/WebDesign/WebDesignPng.png";

function LandingFace() {
  return (
    <div className="HomePageLandingWeb ">
      <div className=" flex flex-row lg:flex-row md:flex-col sm:flex-col xs:flex-col justify-center items-center h-[100vh]   md:h-[100vh] sm:h-[100vh] xs:h-[100vh] w-full  zindex-8">
        <div className=" basis-1/2 md:basis-1/2 sm:basis-3/4 xs:basis-3/4 flex justify-cemter items-end p-8 md:p-8 sm:p-4 xs:p-4">
          <img src={WebGraphic} className="w-[100%] lg:w-[100%] md:w-[100%] " />
        </div>
        <div className=" mt-20 sm:mt-0 xs:mt-0 basis-1/2 md:basis-1/2 sm:basis-1/4 xs:basis-1/4  p-8 md:p-8 sm:p-4 xs:p-4 flex justify-center  flex-col items-start mt-[30vh] w-full h-[100vh] ">
          <h3 className="text-[#333] font-black text-[50px] md:text-5xl sm:text-3xl xs:text-3xl">
            Build Your <br className="block md:block sm:hidden xs:hidden " />
            Business <br className="hidden md:hidden  sm:block xs:block " /> To High{" "}
            <br className="block md:hidden sm:hidden xs:hidden " />
            Standard
          </h3>
          <p className="block md:block sm:hidden xs:hidden  w-[70%] md:w-[90%] xs:w-[90%] sm:w-[90%] text-[#111] leading-1 mt-8 sm:mt-4 xs:mt-4 text-xl md:text-xl sm:text-lg xs:text-lg ">
            we believe in setting the highest standards for our business
            operations to deliver exceptional products and services to our
            valued customers.
          </p>
          <button className="mt-8 sm:mt-4 xs:mt-4 Whiteshadow text-xl  Primary text-white w-40 text-center rounded-tr-full rounded-br-full rounded-bl-full h-12">
            Check More
          </button>

          {/* Blocks and icons */}
          <div className="mt-8 sm:mt-4 xs:mt-4  flex-row gap-3 flex md:flex sm:hidden xs:hidden    px-4 py-2 rounded-full whiteshadow">
            <div className="w-12  h-12 bg-white md:bg-white sm:bg-black xs:bg-black darkshadow flex justify-center items-center rounded-full">
              <Instagram className="important font-xl secondary" />
            </div>
            <div className="w-12 h-12 bg-white md:bg-white sm:bg-black  xs:bg-black darkshadow flex justify-center items-center rounded-full">
              <Facebook className="important font-xl secondary" />
            </div>
            <div className="w-12 h-12 bg-white md:bg-white darkshadow sm:bg-black xs:bg-black flex justify-center items-center rounded-full">
              <LinkedIn className="important font-xl secondary" />
            </div>
            <div className="w-12 h-12 bg-white md:bg-white darkshadow sm:bg-black xs:bg-black flex justify-center items-center rounded-full">
              <Twitter className="important font-xl secondary" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingFace;
